export enum IPackCancelledWorkstationType {       
    None = 0,      
    Small = 1,      
    Medium = 2,      
    Large = 4,      
    XLarge = 8,      
    Manual = 16,      
    Paused = 128,
}
  